// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"146":"32b2c19c","163":"8288dc9b","223":"711e2a22","358":"31fc1784","591":"2800b607","956":"5762366d"}[chunkId] + ".chunk.js";
};